import mainFaqData from '../../assets/data/mainFaq.json';
import Footer from '../../components/Footer/Footer';
import styles from './HomeMobile.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import rightArrow from '../../assets/rightArrow.png';
import MainFaqFrameMobile from '../../mobileComponents/MainFaqFrameMobile/MainFaqFrameMobile';
import MainReviewFrame from '../../components/MainReviewFrame/MainReviewFrame';
import { IReviewDataType } from '../../pages/MyReview/MyReview';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { loginCheck } from '../../auth/auth';
import ReviewFilter from '../../components/ReviewFilter/ReviewFilter';
import processImage01 from '../../assets/processImage01.png';
import processImage02 from '../../assets/processImage02.png';
import processImage03 from '../../assets/processImage03.png';
import review from '../../assets/review.png';
import ondocServiceM from '../../assets/ondocServiceM.png';
import { IProductListType } from '../../pages/ProductList/ProductList';
import banner1 from '../../assets/banner/mobileMainBanner01.jpg';
import banner3 from '../../assets/banner/mobileMainBanner03.jpg';
import banner4 from '../../assets/banner/mobileMainBanner04.jpg';
import banner5 from '../../assets/banner/mobileMainBanner05.jpg';
import banner6 from '../../assets/banner/mobileMainBanner06.jpg';
import banner7 from '../../assets/banner/mobileMainBanner07.jpg';
import banner10 from '../../assets/banner/mobileMainBanner10.jpeg';
import LazyLoad from 'react-lazy-load';
import { IAdLinkDataType } from '../../pages/Home/Home';
import ADLink from '../../components/ADLink/ADLink';
import { IBannerType } from '../../components/MainBanner/MainBanner';
import Header from '../../components/Header/Header';
import Popup from '../../components/Popup/Popup';
import { useCookies } from 'react-cookie';

const defaultMobileBannerList: IBannerType[] = [
  { image: banner10, url: 'productDetail/1' },
];

const mainFaqList = mainFaqData;

function HomeMobile() {
  const location = useLocation();
  const navigate = useNavigate();
  //배너
  const [activeIdx, setActiveIdx] = useState(0);
  const [processList, setProcessList] = useState<IBannerType[]>([]);
  const { data: apiBannerData = [] } = useQuery<IBannerType[]>(
      'banner-advertisement-mobile',
      async () => {
        return await axiosClient
            .get('/data/banner/advertisement')
            .then((res) =>
                res.data.map((banner: any) => ({
                  image: banner.mobile_image,
                  url: banner.link
                }))
            );
      },
      {
        staleTime: 60000 * 60, // 1 hour cache
      }
  );
  useEffect(() => {
    setProcessList(() => {
      let list: IBannerType[] = [
        { image: processImage01 },
        { image: processImage02 },
        { image: processImage03 },
      ];
      return [...list];
    });
  }, []);
  const slideList = apiBannerData.length > 0 ? apiBannerData : defaultMobileBannerList;
  const [swiper, setSwiper] = useState<SwiperCore>();
  //배너
  //상품
  const { data: productList } = useQuery<IProductListType[]>(
    ['productList', 'all'],
    async () => {
      let queryString = '';
      let ids = JSON.parse(
        sessionStorage.getItem('product_ids') || JSON.stringify([]),
      );
      if (ids.length) {
        queryString = 'add_products=';
        ids.map((id: number, idx: number) => {
          queryString += `${id}${idx !== ids.length - 1 ? ',' : ''}`;
        });
      }
      return await axiosClient
        .get(`/data/product/list?${queryString}`)
        .then((res) => res.data.data);
    },
  );
  //상품
  //프로세스
  const [processSliderIdx, setProcessSliderIdx] = useState(0);
  //프로세스
  //회사소개
  const [infoSwiper, setInfoSwiper] = useState<SwiperCore>();
  const [ondocInfoIndex, setOndocInfoIndex] = useState<number>(1);
  //회사소개
  //의사
  const [doctorSwiper, setDoctorSwiper] = useState<SwiperCore>();
  const [doctorInfoIndex, setDoctorInfoIndex] = useState<number>(1);
  const handleDoctorInfoChange = (doctorSwiper: SwiperCore) => {
    setDoctorInfoIndex(doctorSwiper.realIndex);
  };
  //의사
  const { data: reviewData } = useQuery<IReviewDataType[]>(
    ['main', 'photo_review'],
    () =>
      axiosClient
        .get(
          '/data/product_talk/photo-review-list?&talk_type=상품평가&limit=5&order_by=star',
        )
        .then((res) => res.data.data),
    {
      staleTime: 60000 * 60,
    },
  );
  //review
  //ondocInfo
  const handleOndocInfoChange = (infoSwiper: SwiperCore) => {
    setOndocInfoIndex(infoSwiper.realIndex);
  };

  //기존 상품 url접속시 대응
  useEffect(() => {
    let pn = new URLSearchParams(location.search).get('pn');
    if (!pn) return;
    if (pn == 'product.view') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=N&code=${new URLSearchParams(
            location.search,
          ).get('pcode')}`,
        )
        .then((res) => navigate(res.data.data.url));
    } else if (pn == 'blind_gate') {
      axiosClient
        .get(
          `/data/product/get_new_url?is_blind=Y&code=${new URLSearchParams(
            location.search,
          ).get('bc')}`,
        )
        .then((res) => navigate(res.data.data.url));
    }
  }, []);
  //기존 상품 url접속시 대응
  const [adLinkOpen, setAdLinkOpen] = useState(true);
  const [adLinkData, setAdLinkData] = useState<IAdLinkDataType>();
  // useEffect(() => {
  //   axiosClient.get('/data/product/promotional_product').then((res) => {
  //     if (!Object.keys(res.data.data).length) return;
  //     setAdLinkData(res.data.data);
  //   });
  // }, []);

  const [hasCookie, setHasCookie] = useState(true);
  const [cookies, setCookies] = useCookies();

  useEffect(() => {
    if (cookies['week-close']) setHasCookie(true);
    else setHasCookie(false);
  }, []);

  return (
    <>
      {adLinkOpen && adLinkData && (
        <ADLink
          productId={adLinkData.id}
          productName={adLinkData.product_name}
          price={adLinkData.price}
          discountedPrice={adLinkData.sale_price}
          closer={setAdLinkOpen}
        />
      )}
      {/* {!hasCookie && <Popup />} */}
      <div>
        <Header />
        <div className={styles.bannerSliderWrap}>
          <Swiper
            onSwiper={setSwiper}
            slidesPerView={1}
            spaceBetween={0}
            className={styles.bannerSlider}
            onSlideChange={(e) => setActiveIdx(e.activeIndex)}
          >
            {slideList.map((slide, idx) => (
              <SwiperSlide
                key={idx}
                onClick={() => {
                  if (slide.url) navigate('/productDetail/1');
                }}
              >
                <img
                  src={slide.image}
                  alt="banner"
                  style={{ cursor: slide.url ? 'pointer' : 'unset' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          {slideList.length > 1 && (
            <ul className={styles.paginationWrap}>
              {slideList.map((banner, idx) => (
                <li
                  key={idx}
                  onClick={() => swiper?.slideTo(idx, 200)}
                  className={idx === activeIdx ? styles.hit : ''}
                ></li>
              ))}
            </ul>
          )}
        </div>
        {/* <div className={styles.prescriptionProductWrap}>
          <h3 onClick={() => navigate(`/productDetail/1`)}>
            <span>글로우라인 상품</span>
            <img src={rightArrow} alt="rightArrow" />
          </h3>
          <Swiper slidesPerView={1} spaceBetween={20}>
            {productList &&
              productList
                ?.filter((product) => product.is_prescription === 1)
                .map((product, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className={styles.productSlideWrap}
                      onClick={() =>
                        navigate(`/productDetail/1`)
                      }
                    >
                      <div className={styles.productThumbnailWrap}>
                        <img
                          src={product.list_image + '?w=530'}
                          alt="productThumbnail"
                        />
                      </div>
                      <div className={styles.productInfoWrap}>
                        <span className={styles.productTag}>BEST</span>
                        <h3 className={styles.productTitle}>글로우라인 밸런스드 슬리밍</h3>
                        <p className={styles.productDescription}>
                          글로우라인의 8가지 성분이 독창적인 배합 기술로 <br />
                          특허 출원되어 믿을 수 있고 검증된 상품입니다.
                        </p>
                        <button
                          className={styles.productButton}
                          onClick={() =>
                            navigate('/productDetail/1')
                          }
                        >
                          구매하러 가기
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
          </Swiper>
        </div> */}
        <div className={styles.reviewWrap}>
          <h3 onClick={() => navigate(`/review/all`)}>
            <span>글로우라인 실시간리뷰</span>
            <img src={rightArrow} alt="rightArrow" />
          </h3>
          <div className={styles.reviewSliderWrap}>
            <LazyLoad>
              <Swiper
                slidesPerView={1.5}
                spaceBetween={10}
                className={styles.reviewSlider}
                breakpoints={{ 700: { slidesPerView: 2.8 } }}
              >
                {reviewData
                  ?.filter((review) => review.product?.list_image)
                  .map((review) => (
                    <SwiperSlide key={review.id}>
                      <MainReviewFrame review={review} />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </LazyLoad>
            {!loginCheck() && <ReviewFilter borderRadius={0} />}
          </div>
        </div>
        <div className={styles.faqWrap}>
          <h3 onClick={() => navigate(`/faq`)}>
            <span>글로우라인 FAQ</span>
            <img src={rightArrow} alt="rightArrow" />
          </h3>
          <ul>
            {mainFaqList.map((faq, idx) => (
              <MainFaqFrameMobile faq={faq} key={idx} />
            ))}
          </ul>
        </div>
        <div className={styles.ondocService}>
          <span className={styles.bigText}>
            원격 진료를 쉽고 <br /> 정확하게
          </span>
          <span className={styles.smallText}>
            병원을 방문하지 않고도 언제 어디서나 <br />
            손쉽게 정확한 진료를 받을 수 있습니다.
          </span>
        </div>
        <div className={styles.ondocService2}>
          <span className={styles.bigText}>
            처방약을 간편하고 <br /> 신속하게
          </span>
          <span className={styles.smallText}>
            의료 서비스 이용이 어려운 분들에게 처방된 <br />
            약을 간편하고 신속하게 배송해 드립니다.
          </span>
        </div>
        <div className={styles.ondocService3}>
          <span className={styles.bigText}>정성과 과학이 결합되어</span>
          <span className={styles.smallText}>
            검증된 약재와 맞춤 처방으로 안전하고 <br />
            효과적인 결과를 추구하며 식약처 인증 <br />
            의약품만 사용합니다.
          </span>
        </div>
        <div className={styles.serviceInfoWrap}>
          <div className={styles.serviceInfoText}>
            한방의 전통적인 지혜와 <br />
            최신 기술이 결합된 <br />
            <div className={styles.inlineWrap}>
              <span>
                글로우라인의 비대면 진료 <br />
                서비스를
              </span>
              <span>경험해보세요!</span>
            </div>
          </div>
          <div className={styles.additionalText}>
            병원에 가지 않고도 언제 어디서나 손쉽게 받을 수 <br />
            있는 한방 비대면 진료 서비스! <br />더 건강한 라이프스타일을
            만들어보세요.
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default HomeMobile;
